export default {"src":"/_next/static/media/ReviewLogo2.40cda389.svg","height":127,"width":186,"blurWidth":0,"blurHeight":0};